import React from 'react';

const EmailObfuscationWrapper = ({ children }) => {
  return (
    <span
      suppressHydrationWarning
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: `<!--email_off-->${children}<!--/email_off-->`,
      }}
    />
  );
};

export default EmailObfuscationWrapper;
